import { DynamicTag } from '@/components/shared/dynamic-tag'
import { RichText } from '@/components/shared/rich-text'
import { FeatureMatrixStoryblok } from '@/lib/types/component-types-sb'
import { DynamicIconName } from '@/lib/types/icon'
import { cn } from '@/lib/utils'
import { storyblokEditable } from '@storyblok/react/rsc'
import { DynamicIcon } from 'lucide-react/dynamic'

type FeatureMatrixProps = {
  blok: FeatureMatrixStoryblok
}

export function FeatureMatrix({ blok }: FeatureMatrixProps) {
  const layout = blok.layout ?? 'stacked'

  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border has-y-borders border-y py-10"
    >
      <div
        className={cn(
          'page-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
          layout === 'stacked' && 'gap-6',
        )}
      >
        {blok.items?.map((item, i) => (
          <div
            {...storyblokEditable(item)}
            key={item._uid}
            className={cn({
              'flex p-6 lg:p-3': true,
              'flex-col gap-3 p-2 lg:gap-6': layout === 'stacked',
              'flex-row items-center gap-3': layout === 'horizontal',
            })}
          >
            {item.icon && (
              <DynamicIcon
                key={item._uid + item.icon}
                size={40}
                className="text-brand"
                strokeWidth={1.5}
                name={item.icon as DynamicIconName}
              ></DynamicIcon>
            )}
            <div key={item._uid + 'content'}>
              <DynamicTag
                as={blok.headingType}
                className="text-accent-foreground mb-1 font-medium"
              >
                {item.title}
              </DynamicTag>
              <RichText content={item.content}></RichText>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
